import { render } from "./GrigliaFacile.vue?vue&type=template&id=6a9bc83e&scoped=true"
import script from "./GrigliaFacile.vue?vue&type=script&lang=js"
export * from "./GrigliaFacile.vue?vue&type=script&lang=js"

import "./GrigliaFacile.vue?vue&type=style&index=0&id=6a9bc83e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9bc83e"]])

export default __exports__